import { Component, inject, Input } from '@angular/core';
import { TenantItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-tenant-badge',
  templateUrl: './tenant-badge.component.html',
  styleUrls: ['./tenant-badge.component.scss']
})
export class TenantBadgeComponent {
  readonly router = inject(Router);

  @Input()
  @Tracked()
  tenant?: TenantItemDto;

  @Input()
  @Tracked()
  disableLink = false;
}
